export default __webpack_public_path__ + "static/media/arrowBack.2f5941d6.svg";